// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navigation.v-navigation-drawer--is-mouseover[data-v-3c84dd04]{box-shadow:0 0 10px 2px rgba(0,0,0,.75)}.navigation.v-navigation-drawer .v-icon.v-icon[data-v-3c84dd04]{font-size:20px;margin:0 auto}.navigation.v-navigation-drawer .v-list-item .v-list-item__content[data-v-3c84dd04]{padding:6px 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
